import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { ExistingUploadFile } from "../types/configurableUpload";

interface ConfigurableOverwriteDialogProps {
  open: boolean;
  confirmationMessage?: string | null;
  existingFiles: ExistingUploadFile[];
  onCancel: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

const ConfigurableOverwriteDialog: React.FC<ConfigurableOverwriteDialogProps> = ({
  open,
  confirmationMessage,
  existingFiles,
  onCancel,
  onConfirm,
  isSubmitting = false,
}) => {
  return (
    <Dialog open={open} onClose={isSubmitting ? undefined : onCancel} fullWidth maxWidth="sm">
      <DialogTitle>Confirm overwrite</DialogTitle>
      <DialogContent dividers>
        <Typography sx={{ mb: 2 }}>
          {confirmationMessage ??
            "A file already exists for this upload target. Confirm overwrite to continue."}
        </Typography>
        {existingFiles.length > 0 && (
          <List dense>
            {existingFiles.map((file) => (
              <ListItem key={file.name} disablePadding>
                <ListItemText primary={file.name} />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" disabled={isSubmitting}>
          Confirm overwrite
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfigurableOverwriteDialog;
